import * as React from 'react'
import MediaQuery from 'react-responsive'
import { connect } from 'react-redux'
import {
  Text,
  StackChildren,
  InlineChildren,
  Breakpoints,
} from '@doordash/design-language'
import Button from '@doordash/component-button'
import * as DA from '../../../typeModules/events'
import {
  ANDROID_CANCEL_DEEPLINK,
  IOS_CANCEL_DEEPLINK,
} from '../../pages/privacy-portal'
import ResponsiveWrapper from '../../atoms/responsive-wrapper'
import s from './strings'
import { OsTypes } from '../../../webview/types'
import { isWebview, detectWebviewOs } from '../../../utilities/userAgent'
import DeleteBlocking from '../../atoms/images/privacy-portal/delete-blocking/DeleteBlocking'
import * as events from '../../../events'
import { noop } from 'lodash'

type Props = {
  trackRTF?: (data: DA.RTF) => void
  unpaidBalance: number
}

const PAGE_NAME = 'block-deletion'
const os = detectWebviewOs()
const PAYOUR_URL = 'https://www.doordash.com/dasher/payment/payout'

export const BlockDeletion: React.FC<Props> = ({
  trackRTF = noop,
  unpaidBalance
}) => {
  React.useEffect(() => {
    trackRTF({ action: DA.GDPRActions.Render, name: PAGE_NAME })
  }, [trackRTF])
  
  const handleContinueClick = () => {
    trackRTF({ action: DA.GDPRActions.Submission, name: PAGE_NAME })
    window.location.href = PAYOUR_URL
  }

  const handleCancelClick = () => {
    trackRTF({ action: DA.GDPRActions.Close, name: PAGE_NAME })
    if (isWebview()) {
      window.location.assign(
        os === OsTypes.iOS ? IOS_CANCEL_DEEPLINK : ANDROID_CANCEL_DEEPLINK
      )
    } else {
      window.location.reload()
    }
  }

  return (
    <ResponsiveWrapper>
    <StackChildren size={StackChildren.Sizes.Large}>
      <InlineChildren justifyContent={InlineChildren.Justification.Center}>
        <DeleteBlocking />
      </InlineChildren>
      <Text styles={Text.Styles.PageTitle2}>{s.blockDeletion.pageTitle(unpaidBalance.toString())}</Text>
      <Text styles={Text.Styles.Body1}>{s.blockDeletion.body1()}</Text>
      <Text styles={Text.Styles.Body1}>{s.blockDeletion.body2()}</Text>
      <MediaQuery minWidth={Breakpoints.Mobile + 1}>
        <InlineChildren
          size={InlineChildren.Sizes.XxSmall}
          justifyContent={InlineChildren.Justification.FlexEnd}
        >
          <Button
            onClick={handleCancelClick}
            type={Button.Types.Tertiary}
            isInline
          >
            {s.blockDeletion.cancelButton()}
          </Button>
          <Button onClick={handleContinueClick} isInline>
            {s.blockDeletion.payoutButton()}
          </Button>
        </InlineChildren>
      </MediaQuery>
    </StackChildren>
    <MediaQuery maxWidth={Breakpoints.Mobile}>
      <StackChildren size={StackChildren.Sizes.Small}>
        <Button onClick={handleContinueClick}>
          {s.blockDeletion.payoutButton()}
        </Button>
        <Button onClick={handleCancelClick} type={Button.Types.FlatSecondary}>
          {s.blockDeletion.cancelButton()}
        </Button>
      </StackChildren>
    </MediaQuery>
  </ResponsiveWrapper>
  )
}

const mapDispatchToProps = {
  trackRTF: events.trackRTF,
}

export default connect(null, mapDispatchToProps)(BlockDeletion)
